import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  WOW,
} from 'config/providers';
import { SpectrumTheme } from 'config/themes';
import { spectrumRedirectUrl } from 'config/redirectUrls';

// Changelog - https://updater.atlassian.net/browse/COREX-1229
export const SpectrumBravePartner: SingleProviderConfig = {
  name: 'SpectrumBravePartner',
  micrositeCode: 'SpectrumBrave',
  mainProvider: Spectrum,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'spectrumspecial.com',
  homepage: 'https://spectrumspecial.com/deals1',
  title: 'Spectrum Authorized Dealer',
  fallbackPhoneNumber: '855-553-4340',
  fallbackLeadModePhoneNumber: '855-550-1068',
  defaultCheckoutType: CheckoutType.PROVIDER_REDIRECT,
  defaultTheme: SpectrumTheme,
  needsDcSession: true,
  source: 'Spectrum',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [Comcast, Cox, Optimum, Mediacom, WOW],
  updaterCrossSellActive: false,
  getProviderRedirectUrl: spectrumRedirectUrl,
};
